<template>
  <div>
    <div class="mb-4">
      <b-row>
        <b-col>
          <base-input label="Critérios:" :show-warning="revisao('criterios')">
            <Editor v-model="oportunidade.criterios" />
            <b-form-invalid-feedback :state="validateState('criterios')"
              >Critérios é um campo obrigatório.</b-form-invalid-feedback
            >
          </base-input>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <b-row>
        <b-col>
          <base-input label="Outras informações:" :show-warning="revisao('observacao')">
            <Editor v-model="oportunidade.outras_informacoes" />
            <b-form-invalid-feedback
              :state="validateState('outras_informacoes')"
              >Outras informações é um campo
              obrigatório.</b-form-invalid-feedback
            >
          </base-input>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <b-row>
        <b-col>
          <b-form-group label="Campos Dinâmicos:">
            <CamposDinamicos v-model="campos_dinamicos" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Form/Editor";
import CamposDinamicos from "@/components/Form/CamposDinamicos";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import BaseInput from "./BaseInput.vue";

export default {
  mixins: [validationMixin],
  components: {
    Editor,
    CamposDinamicos,
    BaseInput,
  },
  data: () => ({}),
  validations: {
    oportunidade: {
      criterios: {},
      outras_informacoes: {},
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    campos_dinamicos: {
      set(value) {
        this.oportunidade.campos_dinamicos = value;
      },
      get() {
        let response = this.oportunidade.campos_dinamicos;
        if (typeof response !== "object" || Array.isArray(response)) {
          response = {};
        }
        return response;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    revisao(campo) {
      if (!this.oportunidade || !this.oportunidade.campos_revisao) return false;
      return this.oportunidade.campos_revisao.some(
        (item) => item.campo === campo
      );
    },
  },
};
</script>
